import { useState, useEffect } from 'react';
import { useUtility } from '../utilityReactProvider';
export var useActiveOrganization = function () {
    var Organizations = useUtility().Organizations;
    var _a = useState(function () { return Organizations === null || Organizations === void 0 ? void 0 : Organizations.getActiveOrganizationId(); }), activeOrgId = _a[0], setActiveOrgId = _a[1];
    var _b = useState(function () { return Organizations === null || Organizations === void 0 ? void 0 : Organizations.getActiveOrganization(); }), activeOrg = _b[0], setActiveOrg = _b[1];
    useEffect(function () {
        if (!Organizations) {
            throw new Error('The Utility provided does not include Organizations module, ensure you are using the right version');
        }
        var updateActiveOrg = function (event) {
            setActiveOrgId(event.detail);
            setActiveOrg(Organizations === null || Organizations === void 0 ? void 0 : Organizations.getActiveOrganization());
        };
        var updateOrg = function (event) {
            if (event.detail.id === activeOrgId) {
                setActiveOrg(Organizations === null || Organizations === void 0 ? void 0 : Organizations.getActiveOrganization());
            }
        };
        window.addEventListener('orgUpdated', updateOrg);
        window.addEventListener('orgChanged', updateActiveOrg);
        return function () {
            window.removeEventListener('orgUpdated', updateOrg);
            window.removeEventListener('orgChanged', updateActiveOrg);
        };
    }, []);
    return {
        organizationId: activeOrgId,
        organization: activeOrg,
        setOrganization: Organizations === null || Organizations === void 0 ? void 0 : Organizations.setActiveOrganizationId,
        updateActiveOrganization: Organizations === null || Organizations === void 0 ? void 0 : Organizations.updateOrganization,
    };
};
